export default function ConcernIcon(props) {
  return (
    <svg
      width="134"
      height="123"
      viewBox="0 0 134 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M69.6081 100.422C97.1963 100.422 119.563 78.0855 119.563 50.4351C119.563 22.7847 97.1963 0.447937 69.6081 0.447937C42.0199 0.447937 19.6537 22.7847 19.6537 50.4351C19.6537 78.0855 42.0199 100.422 69.6081 100.422Z"
        fill="#F8F4F9"
      />
      <path
        d="M125.277 34.7895C127.508 34.7895 129.317 32.9832 129.317 30.755C129.317 28.5269 127.508 26.7207 125.277 26.7207C123.046 26.7207 121.237 28.5269 121.237 30.755C121.237 32.9832 123.046 34.7895 125.277 34.7895Z"
        fill="#F8F4F9"
      />
      <path
        d="M131.189 18.9471C132.712 18.9471 133.948 17.7135 133.948 16.1919C133.948 14.6702 132.712 13.4367 131.189 13.4367C129.666 13.4367 128.43 14.6702 128.43 16.1919C128.43 17.7135 129.666 18.9471 131.189 18.9471Z"
        fill="#F8F4F9"
      />
      <path
        d="M16.2051 37.643C17.7288 37.643 18.9639 36.4094 18.9639 34.8879C18.9639 33.3662 17.7288 32.1327 16.2051 32.1327C14.6815 32.1327 13.4463 33.3662 13.4463 34.8879C13.4463 36.4094 14.6815 37.643 16.2051 37.643Z"
        fill="#F8F4F9"
      />
      <path
        d="M86.7521 21.5479C103.761 21.5479 117.482 33.9015 117.482 49.0885C117.482 57.8153 112.945 65.6354 105.802 70.7355V82.1825C105.802 83.7692 103.988 84.5625 102.854 83.6558L93.102 76.0623C91.061 76.4024 89.0199 76.629 86.8655 76.629C69.8567 76.629 56.1362 64.2755 56.1362 49.0885C56.1362 33.9015 69.8566 21.5479 86.7521 21.5479Z"
        fill="#CAA5D0"
      />
      <g filter="url(#filter0_d_188_63340)">
        <path
          d="M56.7033 20.1879C37.7668 20.1879 22.4589 33.9015 22.4589 50.7885C22.4589 60.5353 27.5615 69.2621 35.4989 74.8156V87.5092C35.4989 89.2092 37.4266 90.2292 38.7873 89.0959L49.6729 80.7091C51.9407 81.1624 54.2086 81.389 56.5898 81.389C75.5263 81.389 90.8342 67.6754 90.8342 50.7885C90.8342 33.9015 75.5263 20.1879 56.7033 20.1879Z"
          fill="url(#paint0_linear_188_63340)"
        />
      </g>
      <path
        d="M48.2682 17.3116C48.1315 17.3116 47.9947 17.3116 47.858 17.3116C47.1744 17.0383 46.7643 16.355 46.9009 15.6718L49.2252 8.15579C49.4987 7.47252 50.1823 7.06257 50.8659 7.19922C51.5495 7.47252 51.9596 8.15579 51.823 8.83906L49.6354 16.355C49.4987 16.9017 48.9518 17.3116 48.2682 17.3116Z"
        fill="#9B4C97"
      />
      <path
        d="M42.5258 18.9514C41.979 18.9514 41.432 18.5415 41.1586 17.9949L37.6039 7.19926C37.3304 6.516 37.7405 5.69607 38.4241 5.42277C39.1077 5.14946 39.9281 5.55942 40.2015 6.24268L43.7563 17.0383C44.0298 17.7216 43.6196 18.5415 42.936 18.8149C42.7992 18.9514 42.6626 18.9514 42.5258 18.9514Z"
        fill="#9B4C97"
      />
      <path
        d="M37.1936 21.5479C36.7834 21.5479 36.51 21.4113 36.2366 21.138L31.8615 16.9018C31.3146 16.3552 31.3146 15.5352 31.8615 14.9886C32.4083 14.442 33.2287 14.442 33.7755 14.9886L38.1506 19.2248C38.6976 19.7714 38.6976 20.5914 38.1506 21.138C37.8772 21.4113 37.467 21.5479 37.1936 21.5479Z"
        fill="#9B4C97"
      />
      <defs>
        <filter
          id="filter0_d_188_63340"
          x="12.4589"
          y="14.1879"
          width="88.3754"
          height="89.3867"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.909804 0 0 0 0 0.839216 0 0 0 0 0.921569 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_188_63340" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_188_63340"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_188_63340"
          x1="56.6245"
          y1="18.5829"
          x2="56.6245"
          y2="90.322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="0.9964" stop-color="#F8F4F9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
